import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card } from '@/components/layout';
import { MainSection } from '@/components/layout/MainSection';
import TournamentSettingsForm from '@/widgets/TournamentSettingsForm';
import { useTournamentDetailContext } from '@/layouts/TournamentDetailLayout/context';

const SettingsTab: React.FC = () => {
  const { tournament, refetchTournament } = useTournamentDetailContext();
  const navigate = useNavigate();
  const { t } = useTranslation(['tournament']);

  return (
    <MainSection
      hideTitleOnDesktop
      title={tournament?.name || 'Tournament'}
      subtitle={t('tournament:settings')}
      logoUrl={tournament?.league?.logo_url || tournament?.leagueLogo}
      logoAlt={tournament?.league?.name || tournament?.leagueName}
    >
      <Card>
        <TournamentSettingsForm
          tournament={tournament}
          onSuccess={() => refetchTournament()}
          onArchived={() => navigate('/tournaments')}
        />
      </Card>
    </MainSection>
  );
};

export default SettingsTab;
